<wiz-vgroup width="100%" height="100%" class="section-container-parent" padding="5px">
  
  <wiz-hgroup width="100%" height="100%">

    <wiz-vgroup width="350px" height="100%" class="section-container"><!-- zone champs libres -->
      <wiz-label [wizLabel]="'$.freedata.edit.field.all.$'" class="smallTitleLabel"></wiz-label>
      <wiz-list
        #freeList
        id="freeList"
        height="100%"
        width="100%"
        [wizItemRenderer]="renderer"
        [wizDataProvider]="dataSource"
        [wizLabelField]="'fullCode'"
        [dragEnabled]="true"
      ></wiz-list>
      <filter-component #mainFilter> </filter-component>
    </wiz-vgroup>
    
    <!-- zone détail : dyptique --> 
    <wiz-hgroup #vgDetailZone width="100%" height="100%"> 
      
      <!-- zone filtre & groupes --> 
      <wiz-vgroup width="50%" height="100%">
        
        <!-- groupes --> 
        <wiz-vgroup width="100%" height="50%" class="section-container">
          <wiz-hgroup width="100%" class="widget-header" [verticalAlign]="'center'" padding="10px">
            <wiz-icon [wizTooltip]="'$.pivot.edit.field.groups.add.$'" class="image-back-orange" (click)="addGroup()">add</wiz-icon>
            <wiz-icon class="image-purple">icon-column</wiz-icon>
            <wiz-label [wizLabel]="'$.pivot.edit.field.groups.$'" class="smallTitleLabel"></wiz-label>
          </wiz-hgroup>
          <wiz-list
            #lstGroup
            id="lstGroup"
            width="100%"
            height="100%"
            [wizLabelField]="'label'"
            [wizItemRenderer]="groupRenderer"
            [dragEnabled]="true"
            [dropEnabled]="true"
            [enableSelfReorder]="true"
            [shopDropIndicator]="true"
          ></wiz-list>
        </wiz-vgroup>


        <!-- zone filtre --> 
        <wiz-vgroup width="100%" height="50%" class="section-container" ><!-- champs filtres --> 
            <wiz-hgroup width="100%" class="widget-header" [verticalAlign]="'center'" padding="10px">
              <wiz-icon class="image-purple">icon-filters</wiz-icon>
              <wiz-label [wizLabel]="'$.pivot.edit.field.filter.$'" class="smallTitleLabel"></wiz-label>
            </wiz-hgroup>
            <wiz-list
              #lstFilter
              id="lstFilter"
              width="100%"
              height="100%"
              [wizLabelField]="'label'"
              [wizItemRenderer]="renderer"
              [dragEnabled]="true"
              [dropEnabled]="true"
              [enableSelfReorder]="true"
              [shopDropIndicator]="true"
              [dragMove]="true"
            ></wiz-list>
        </wiz-vgroup>

      </wiz-vgroup>

      <!-- <wiz-hgroup width="100%" height="100%"> -->
        <!-- zone lignes et datas -->
        <wiz-vgroup width="50%" height="100%" class="section-container"><!-- champs lignes -->
          <wiz-hgroup width="100%" class="widget-header" [verticalAlign]="'center'" padding="10px">
            <wiz-icon class="image-purple">icon-line</wiz-icon>
            <wiz-label [wizLabel]="'$.pivot.edit.field.row.$'" class="smallTitleLabel"></wiz-label>
          </wiz-hgroup>
          <wiz-list
            #lstRow
            id="lstRow"
            width="100%"
            height="100%"
            [wizLabelField]="'label'"
            [wizItemRenderer]="renderer"
            [dragEnabled]="true"
            [dropEnabled]="true"
            [enableSelfReorder]="true"
            [shopDropIndicator]="true"
            [dragMove]="true"
          ></wiz-list>
        </wiz-vgroup>
        
      <!-- </wiz-hgroup> -->
    <!-- </wiz-vgroup> -->

    </wiz-hgroup>

  </wiz-hgroup>
  
  <!-- footer & validation -->
  <wiz-hgroup width="100%" [horizontalAlign]="'end'" verticalAlign="center" class="section-container">
    <wiz-vgroup width="100%">
      <wiz-checkbox #cbShowDeleteCol [wizLabel]="'$.pivot.edit.show.delete.$'"></wiz-checkbox>
      <wiz-hgroup>
        <wiz-checkbox #cbShowSelectCol [wizLabel]="'$.pivot.edit.show.select.$'"></wiz-checkbox>
        <wiz-checkbox #cbSelectUnique  [wizLabel]="'$.pivot.edit.select.unique.$'"></wiz-checkbox>
      </wiz-hgroup>
        </wiz-vgroup>
    <wiz-button
      #btnSave
      width="150px"
      (click)="doValid()"
      [wizLabel]="'$.common.save.modification.$'"
      [wizIcon]="'icon-arrow-right'"
      [iconPlacement]="'right'"
    ></wiz-button>
    <wiz-button
      #btnCancel
      width="150px"
      (click)="doCancel()"
      class="cancel-button"
      [wizIcon]="'icon-arrow-left'"
      [wizLabel]="'$.common.cancel.modification.$'"
    ></wiz-button>
  </wiz-hgroup>

  
</wiz-vgroup>
